import React, { useEffect, useState } from "react";
import { getAllActive } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";
import { validateTextInput } from "../../../Domain/Helpers/InputValidationHelper";
import { campaignContributionTypeSelect } from "../../../Domain/Constants/CampaignContributionTypeSelect";

function CampaignUpdatePage(props) {
    const [currency, setCurrency] = useState(null);
    const [tenant, setTenant] = useState(null);
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("currency/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available tenants");
            } else {
                setCurrency(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("tenant/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available operators");
            } else {
                setTenant(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (currency && tenant) {
            setInputs([
                {
                    inputType: inputType.SELECT,
                    labelText: "Currency",
                    required: true,
                    inputId: "currency_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(currency, "iso_code")
                }, 
                {
                    inputType: inputType.TEXT,
                    labelText: "Name",
                    required: true,
                    inputId: "name",
                    validationFunction: (value) => validateTextInput(value, "Name", true)
                },
                {
                    inputType: inputType.TEXT,
                    labelText: "Provider Campaign ID",
                    required: true,
                    inputId: "provider_campaign_id",
                    validationFunction: (value) => validateTextInput(value, "Provider Campaign ID", true)
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Contribution Type",
                    required: true,
                    inputId: "contribution_type",
                    validationFunction: () => {return null},
                    selectOptions: campaignContributionTypeSelect
                },
                {
                    inputType: inputType.NUMBER,
                    labelText: "Contribution Amount",
                    required: true,
                    inputId: "contribution_amount",
                    validationFunction: () => {return null},
                    numberStep: "0.00000001"
                },
                {
                    inputType: inputType.NUMBER,
                    labelText: "Minimum Bet",
                    required: true,
                    inputId: "minimum_bet",
                    validationFunction: () => {return null},
                    numberStep: "0.00000001"
                },
                
            ])
        }
    }, [tenant, currency])

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"campaign/update"}
            pageTitle={"Update Campaign"}
            isUpdate={true}
            getEndpoint={"campaign/read"}
            entityName={"Campaign"} />
    )
}

export default CampaignUpdatePage;